<p>
  <img src="/assets/layout/images/logo-dark-small.svg" alt="Logo" />
</p>

<h1 id="title" class="title">{{ site }} Login</h1>

<!--<p class="sub-title">Click the button below to be redirected to our login provider</p>-->

<!--<sec-auth0-login></sec-auth0-login>-->

<!--<p class="sub-title">Hello! Log in with your email.</p>-->

@if (showMessages.error && !submitted && errors.length) {
  <nb-alert outline="danger" role="alert">
    <p class="alert-title"><b>Oh snap!</b></p>
    <ul class="alert-message-list">
      @for (error of errors; track error) {
        <li class="alert-message">{{ error }}</li>
      }
    </ul>
  </nb-alert>
}

@if (showMessages.success && !submitted && messages.length) {
  <nb-alert outline="success" role="alert">
    <p class="alert-title"><b>Hooray!</b></p>
    <ul class="alert-message-list">
      @for (message of messages; track message) {
        <li class="alert-message">
          {{ message }}
        </li>
      }
    </ul>
  </nb-alert>
}

<form (ngSubmit)="login()" #form="ngForm" aria-labelledby="title">
  <div class="form-control-group">
    <label class="label" for="input-email">Email address:</label>
    <input
      nbInput
      fullWidth
      [(ngModel)]="user.email"
      #email="ngModel"
      name="email"
      type="email"
      id="input-email"
      pattern=".+@.+\..+"
      placeholder="Email address"
      fieldSize="large"
      autofocus
      [status]="email.dirty ? (email.invalid ? 'danger' : 'success') : 'basic'"
      [required]="getConfigValue('forms.validation.email.required')"
      [attr.aria-invalid]="email.invalid && email.dirty ? true : null"
    />
    @if (email.invalid && email.dirty) {
      @if (email.errors?.['required']) {
        <p class="caption status-danger">Email is required!</p>
      }
      @if (email.errors?.['pattern']) {
        <p class="caption status-danger">Email should be the real one!</p>
      }
    }
  </div>

  <div class="form-control-group">
    <span class="label-with-link">
      <label class="label" for="input-password">Password:</label>
      <a class="forgot-password caption-2" routerLink="../request-password"
        >Forgot Password?</a
      >
    </span>
    <input
      nbInput
      fullWidth
      [(ngModel)]="user.password"
      #password="ngModel"
      name="password"
      type="password"
      id="input-password"
      placeholder="Password"
      fieldSize="large"
      [status]="
        password.dirty ? (password.invalid ? 'danger' : 'success') : 'basic'
      "
      [required]="getConfigValue('forms.validation.password.required')"
      [minlength]="getConfigValue('forms.validation.password.minLength')"
      [maxlength]="getConfigValue('forms.validation.password.maxLength')"
      [attr.aria-invalid]="password.invalid && password.dirty ? true : null"
    />
    @if (password.invalid && password.dirty) {
      @if (password.errors?.['required']) {
        <p class="caption status-danger">Password is required!</p>
      }
      @if (password.errors?.['minlength'] || password.errors?.['maxlength']) {
        <p class="caption status-danger">
          Password should contain from
          {{ getConfigValue('forms.validation.password.minLength') }} to
          {{ getConfigValue('forms.validation.password.maxLength') }}
          characters
        </p>
      }
    }
  </div>

  <div class="form-control-group accept-group">
    @if (rememberMe) {
      <nb-checkbox name="rememberMe" [(ngModel)]="user.rememberMe"
        >Remember me</nb-checkbox
      >
    }
  </div>

  <button
    nbButton
    fullWidth
    status="primary"
    size="large"
    [disabled]="submitted || !form.valid"
    [class.btn-pulse]="submitted"
  >
    Log In
  </button>
</form>

<section class="links" aria-label="Social sign in">
  or enter with:
  <div class="socials">
    <button nbButton fullWidth status="primary" (click)="loginWithGoogle()">
      <nb-icon icon="google-outline"></nb-icon>
      Google
    </button>
  </div>
</section>

<!--<section-->
<!--  *ngIf="socialLinks && socialLinks.length > 0"-->
<!--  class="links"-->
<!--  aria-label="Social sign in"-->
<!--&gt;-->
<!--  or enter with:-->
<!--  <div class="socials">-->
<!--    <ng-container *ngFor="let socialLink of socialLinks">-->
<!--      <a-->
<!--        *ngIf="socialLink.link"-->
<!--        [routerLink]="socialLink.link"-->
<!--        [attr.target]="socialLink.target"-->
<!--        [attr.class]="socialLink.icon"-->
<!--        [class.with-icon]="socialLink.icon"-->
<!--      >-->
<!--        <nb-icon-->
<!--          *ngIf="socialLink.icon; else title"-->
<!--          [icon]="socialLink.icon"-->
<!--        ></nb-icon>-->
<!--        <ng-template #title>{{ socialLink.title }}</ng-template>-->
<!--      </a>-->
<!--      <a-->
<!--        *ngIf="socialLink.url"-->
<!--        [attr.href]="socialLink.url"-->
<!--        [attr.target]="socialLink.target"-->
<!--        [attr.class]="socialLink.icon"-->
<!--        [class.with-icon]="socialLink.icon"-->
<!--      >-->
<!--        <nb-icon-->
<!--          *ngIf="socialLink.icon; else title"-->
<!--          [icon]="socialLink.icon"-->
<!--        ></nb-icon>-->
<!--        <ng-template #title>{{ socialLink.title }}</ng-template>-->
<!--      </a>-->
<!--    </ng-container>-->
<!--  </div>-->
<!--</section>-->
